import { UseMutationOptions, useMutation } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { ErrorResponse } from '../../../common/validations'
import {
  RegisterInvitedUserInput,
  RegisterInvitedUserResponse,
  registerInvitedUserResponseSchema,
} from '../../../common/validations/invitation'

import { post } from 'api/apiClient'

export const useAPIRegisterInvitedUser = (
  uuid: string,
  options?: UseMutationOptions<
    RegisterInvitedUserResponse,
    ErrorResponse,
    RegisterInvitedUserInput
  >
) =>
  useMutation({
    mutationFn: (data) =>
      post(
        API_ENDPOINTS.INVITATION_REGISTER.replace(':uuid', uuid),
        data,
        registerInvitedUserResponseSchema
      ),
    throwOnError: false,
    ...options,
  })
